import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/common/Logo";
import { Button } from "@/components/ui/button";

export const LandingNav = () => (
  <header className="sticky top-0 z-40 border-b bg-background">
    <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
      <Logo />
      <nav className="hidden items-center gap-7 text-sm font-medium text-muted-foreground md:flex">
        <a href="#how" className="hover:text-foreground">How it works</a>
        <a href="#why" className="hover:text-foreground">Why hosts use it</a>
        <a href="#factors" className="hover:text-foreground">Risk factors</a>
        <Link to="/pricing" className="hover:text-foreground">Pricing</Link>
        <a href="#faq" className="hover:text-foreground">FAQ</a>
      </nav>
      <div className="flex items-center gap-2">
        <Link to="/login"><Button variant="ghost" size="sm" data-testid="nav-login-button">Log in</Button></Link>
        <Link to="/signup"><Button size="sm" data-testid="nav-signup-button">Get started</Button></Link>
      </div>
    </div>
  </header>
);
